import { render, staticRenderFns } from "./EmployeeDivisionCustomer.vue?vue&type=template&id=2495d501&scoped=true&"
import script from "./EmployeeDivisionCustomer.vue?vue&type=script&lang=js&"
export * from "./EmployeeDivisionCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2495d501",
  null
  
)

/* custom blocks */
import block0 from "@/locales/modules/CustomerTranslate.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Flike%2FDocuments%2FComay%2FSources%2FFe%2Flink-fe%2Fsrc%2Fviews%2Fapps%2Fcbs%2Femployee%2FEmployeeDivisionCustomer.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports